import React, { useState } from 'react';
import { track } from '@trello/analytics';
import cx from 'classnames';

import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './SuggestionsFeedback.less';

interface SuggestionsFeedbackProps {
  context: string;
  onClose: () => void;
}

const format = forTemplate('suggestions_feedback');
const MAX_LENGTH = 128;

export const SuggestionsFeedback: React.FunctionComponent<
  SuggestionsFeedbackProps
> = function SuggestionsFeedback({ context, onClose }) {
  const [freeform, setFreeform] = useState('');
  const [useful, setUseful] = useState<boolean | undefined>();

  const submitDisabled = useful === undefined && freeform.length === 0;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        track(
          'Suggestions Feedback',
          context,
          freeform,
          undefined,
          useful === true ? 1 : useful === false ? 0 : undefined,
        );
        onClose();
      }}
    >
      <p>{format('trello-is-collecting-feedback')}</p>
      <label>
        <div className={styles.question}>
          {format('were-these-suggestions-useful')}
        </div>
      </label>
      <div className={styles.useful}>
        <button
          type="button"
          className={cx('button', { [styles.selected]: useful === true })}
          onClick={() => setUseful(useful === true ? undefined : true)}
        >
          {format('yes')}
        </button>
        <button
          type="button"
          className={cx('button', { [styles.selected]: useful === false })}
          onClick={() => setUseful(useful === false ? undefined : false)}
        >
          {format('no')}
        </button>
      </div>

      <label>
        <div className={styles.question}>{format('any-other-feedback')}</div>
        <textarea
          className={styles.freeform}
          maxLength={MAX_LENGTH}
          onInput={(e) => setFreeform(e.currentTarget.value)}
        />
        <div
          className={cx(styles.lengthWarning, {
            [styles.show]: freeform.length > MAX_LENGTH / 2,
          })}
        >
          {MAX_LENGTH - freeform.length}
        </div>
      </label>
      <button
        className={cx('button', styles.submit, { disabled: submitDisabled })}
        type="submit"
        disabled={submitDisabled}
      >
        {format('submit')}
      </button>
    </form>
  );
};
